<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-popup fullscreen title="New Vehicle Wizard" v-if="popupActive"  :active.sync="popupActive">
            <add-driver-popup @exit="closeModal"></add-driver-popup>
            </vs-popup>

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="drivers">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

    
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New Driver</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ drivers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : drivers.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Picture</vs-th>
        <vs-th sort-key="popularity">Name</vs-th>
        <vs-th sort-key="popularity">Licence (Exp)</vs-th>
        <vs-th sort-key="popularity">GDL (Exp)</vs-th>
        <vs-th sort-key="order_status">Phone</vs-th>
        <vs-th sort-key="order_status">Access</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                <img :src="tr.driverImage" width="150" height="100"  style=" border-radius: 20px;"/>
                             </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.fullName }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.licenceExpiry}}</p>
              </vs-td>
                  <vs-td>
                <p class="product-category">{{ tr.gdlExpiry}}</p>
              </vs-td>
               <vs-td>
                <p class="product-category">{{ tr.mobileNumber}}</p>
              </vs-td>

              <vs-td>
              <b>{{ tr.driverUsername + ' [Pwd: '+tr.driverPassword+' ]'}}</b>
              </vs-td>
     

              <vs-td class="whitespace-no-wrap">
         
            
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  class="ml-2"  @click.stop="navigateToDriverView(tr.id)" />
          
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import AddDriverPopup from './AddDriverPopup.vue'


export default {
  components: {
    AddDriverPopup
  },
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('userInfo')),
      selectedVehicle:null,
      popupActive:false,
      popupActive2:false,
      driverData:{

      },  
      drivers:[],
      selected: [],
      // drivers: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
   
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    drivers () {
      return this.$store.state.dataList.drivers
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.drivers.length
    }
  },
  methods: {
    closeModal () {
      const self = this
      self.popupActive = false
      self.getDrivers()
    },
    getDrivers () {
      const self = this
      self.$http.get(`driversAllByUser/${ self.userInfo.uid}`, {

      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.drivers = response.data.drivers
          } else if (response.data.error) {


          } else {

          }
        })
        .catch(function (error) {

        })
    },
    navigateToDriverView (driverId) {
      const routeData = this.$router.resolve({name: 'driver-view', params: {driverId}})
      window.open(routeData.href, '_blank')
    },
    addNewData () {
      this.driverData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold')   return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled')  return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90)  return 'success'
      if (num > 70)  return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50)  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.popupActive = val
    }
  },
  created () {
 
  },
  mounted () {
    this.isMounted = true,
    this.getDrivers()
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
